// This file is part of MinIO Design System
// Copyright (c) 2023 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import React, { SVGProps } from "react";

const MinIOTierIconXs = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 300 300"><defs><clipPath id="a"><path d="M14.695 14.695h270.75v270.75H14.695Zm0 0"/></clipPath></defs><path fill="#c91e1e" fill-rule="evenodd" d="M226.32 73.613h-90.535l19.32-19.32h90.536v38.582Zm-81.828 66.723H73.613V73.613l19.32-19.32H54.349v90.535l14.77 14.77H226.32v66.722L207 245.64h38.586v-90.535l-14.77-14.77ZM54.348 235.98V207l19.32 19.32h90.535l-19.32 19.32H54.348Zm0 0"/><g clip-path="url(#a)"><path fill="#069990" fill-rule="evenodd" d="m141.121 50.867 9.043-9.043h26.902L156.79 21.547l-6.793-6.852-63.86 63.86v27.297Zm17.691 198.258 11.063-11.066 43.922-43.918v27.293l-63.86 63.859-27.125-27.125h26.903Zm-40.437-53.863 23.082-23.082h-27.293l-.957.953-24.039 24.039-47.402-47.402v-26.903l-20.274 20.278-6.797 6.851 6.852 6.793 57.008 57.008h21.23l3.031-3.031Zm63.238-90.535 15.559-15.559 3.035-3.031h21.227l63.859 63.86-6.852 6.792-20.273 20.277v-26.902l-9.043-9.043-7.414-7.36-30.945-30.945-24.04 24.04-.956.953h-27.293Zm0 0"/></g></svg>
  );
};

export default MinIOTierIconXs;
